import { Controller } from '@hotwired/stimulus'

// Trivial client-side filter over the already-rendered concept list.
// Server-side gating decides what's in the list; this only hides cards.
export default class extends Controller {
  static targets = ['input', 'card', 'count']

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.cardTargets.forEach((card) => {
      const match = !query || card.dataset.filterText.includes(query)
      card.hidden = !match
      if (match) visible += 1
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${visible} result${visible === 1 ? '' : 's'}`
    }
  }
}
